import {
    IControlInput,
    IDeviceInformation,
    IDeviceItemGrouping,
    IDeviceNode,
    IDynamicControlsSharedState
} from '../shared/models/device';
import {DeviceInputVisitor} from './device-input-visitor';

// Visits a node that represent a control-input and adds the input to the array $flatDeviceInputs top node
export class FlatDeviceInputVisitor extends DeviceInputVisitor {

    private rootNode: IDeviceNode;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        super.init(rootNode, device, sharedState);
        this.rootNode = rootNode;
        if (!this.rootNode.$flatControlInputs) {
            this.rootNode.$flatControlInputs = [];
        }
        if (!this.rootNode.$flatDynamicCalendars) {
            this.rootNode.$flatDynamicCalendars = [];
        }
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let controlInput =  propValue as IControlInput;

        this.rootNode.$flatControlInputs.push(controlInput);

        controlInput.$fieldName = this.sharedState.nextId();
        this.service.setControlInputType(controlInput);

        return null;
    }
}
